import type { PaginationType } from '../types/Pagination.types';
import { z } from 'zod';
import { MediaDtoSchema } from '../media/media.schema';
import { PaginationParamsSchema } from '../types/Pagination.types';
import { ProgressStatusAppearance } from './progress-statuses.enum';

const PresentationSchema = z.object({
  key: z.string(),
  statusUpToCoins: z.number().nullable().optional(),
});

export const ProgressStatusAssetDtoSchema = z.object({
  id: z.string().uuid(),
  mediaId: z.string().uuid(),
  progressStatusId: z.string().uuid(),
  media: MediaDtoSchema,
  appearance: z.nativeEnum(ProgressStatusAppearance),
  createdAt: z.string(),
  updatedAt: z.string(),
}).describe('ProgressStatusAssetDtoSchema');

export const ProgressStatusDtoSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  levelFrom: z.number(),
  levelTo: z.number().nullable().optional(),
  presentation: PresentationSchema.nullable().optional(),
  assets: z.array(ProgressStatusAssetDtoSchema),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
}).describe('ProgressStatusDtoSchema');

export const ProgressStatusBonusDto = z.object({
  goldCoin: z.object({
    min: z.number().default(0),
    max: z.number().default(0),
  }),
  sweepCoin: z.object({
    min: z.number().default(0),
    max: z.number().default(0),
  }),
  bonusSweepCoin: z.object({
    min: z.number().default(0),
    max: z.number().default(0),
  }),
}).describe('ProgressStatusBonusDto');

export const ExtendedProgressStatusDtoSchema = ProgressStatusDtoSchema.extend({
  bonus: ProgressStatusBonusDto,
}).describe('ExtendedProgressStatusDtoSchema');

export const ProgressStatusFiltersSchema = z.object({
  id: z.string().uuid().optional(),
  name: z.string().optional(),
  levelFrom: z.number().optional(),
  levelTo: z.number().nullable().optional(),
}).optional().describe('ProgressStatusFiltersSchema');

export const ProgressStatusParamsSchema = PaginationParamsSchema(ProgressStatusFiltersSchema);

export type ProgressStatusAssetDto = z.infer<typeof ProgressStatusAssetDtoSchema>;

export type ProgressStatusDto = z.infer<typeof ProgressStatusDtoSchema>;
export type ExtendedProgressStatusDto = z.infer<typeof ExtendedProgressStatusDtoSchema>;
export type ProgressStatusListDto = PaginationType<ExtendedProgressStatusDto>;

export type ProgressStatusParams = z.infer<typeof ProgressStatusParamsSchema>;
